// extracted by mini-css-extract-plugin
export var layoutContainer = "_7g-0";
export var layoutContainerNoRounding = "_7g-6";
export var layoutContainerOpen = "_7g-5";
export var layoutContainerResizing = "_7g-1";
export var mainContent = "_7g-2";
export var resizeDivider = "_7g-3";
export var slidePanel = "_7g-4";